"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfOfferContractDataDto = instanceOfOfferContractDataDto;
exports.OfferContractDataDtoFromJSON = OfferContractDataDtoFromJSON;
exports.OfferContractDataDtoFromJSONTyped = OfferContractDataDtoFromJSONTyped;
exports.OfferContractDataDtoToJSON = OfferContractDataDtoToJSON;
exports.OfferContractDataDtoToJSONTyped = OfferContractDataDtoToJSONTyped;
/**
 * Check if a given object implements the OfferContractDataDto interface.
 */
function instanceOfOfferContractDataDto(value) {
    if (!('file' in value) || value['file'] === undefined)
        return false;
    if (!('mimeType' in value) || value['mimeType'] === undefined)
        return false;
    if (!('fileName' in value) || value['fileName'] === undefined)
        return false;
    if (!('size' in value) || value['size'] === undefined)
        return false;
    return true;
}
function OfferContractDataDtoFromJSON(json) {
    return OfferContractDataDtoFromJSONTyped(json, false);
}
function OfferContractDataDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'file': json['file'],
        'mimeType': json['mimeType'],
        'fileName': json['fileName'],
        'size': json['size'],
    };
}
function OfferContractDataDtoToJSON(json) {
    return OfferContractDataDtoToJSONTyped(json, false);
}
function OfferContractDataDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'file': value['file'],
        'mimeType': value['mimeType'],
        'fileName': value['fileName'],
        'size': value['size'],
    };
}
